/**
 * Helpers Supabase pour les zones maritimes (table regions, niveau L1).
 */

import { supabase } from './supabase.js';
import { getLang } from './i18n.js';

const ZONE_ICONS = {
  'mediterranee':   '🌊',
  'mer-rouge':      '🐡',
  'mer-noire':      '🌑',
  'caraïbes':       '🐠',
  'atlantique-nord':'🌬️',
  'pacifique-nord': '🐬',
  'indopacifique':  '🪸',
  'ocean-arctique': '🧊',
  'ocean-austral':  '🐧',
};

export function zoneIcon(slug) {
  return ZONE_ICONS[slug] ?? '🌊';
}

export function zoneName(zone) {
  if (getLang() === 'en' && zone.name_en) return zone.name_en;
  return zone.name_fr ?? zone.slug;
}

/**
 * Retourne les zones top-level actives (avec au moins une espèce dans le catalogue).
 * Essaie d'abord via la fonction SQL list_active_zones() (accès direct à name_fr/name_en).
 * Fallback sur la requête table directe si le cache PostgREST n'a pas encore les colonnes.
 */
export async function listActiveZones() {
  const { data: rpcData, error: rpcError } = await supabase.rpc('list_active_zones');
  if (!rpcError) return rpcData ?? [];

  // Fallback : colonnes de base connues du cache (name = nom français)
  const { data, error } = await supabase
    .from('regions')
    .select('id, slug, name, species_regions(species_id)')
    .is('parent_id', null)
    .order('name', { ascending: true });

  if (error) throw error;

  return (data ?? [])
    .filter(r => r.species_regions.length > 0)
    .map(r => ({
      id:            r.id,
      slug:          r.slug,
      name_fr:       r.name,
      name_en:       null,
      species_count: r.species_regions.length,
    }));
}

/**
 * Récupère une zone par son ID.
 * Utilise la colonne `name` (rétrocompatibilité) et la mappe en name_fr.
 */
export async function getZone(id) {
  const { data, error } = await supabase
    .from('regions')
    .select('id, slug, name')
    .eq('id', id)
    .single();
  if (error) throw error;
  return { ...data, name_fr: data.name, name_en: null };
}
